
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11206",
                "data-name": "矩形 11206",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(94 404)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_246",
        "data-name": "蒙版组 246",
        "class": "cls-2",
        "transform": "translate(-94 -404)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "zhuoyi",
            "class": "cls-3",
            "d": "M.45,0A.461.461,0,0,1,.9.471v8H6.75a.471.471,0,0,1,0,.941H6.3v6.118a.45.45,0,1,1-.9,0V11.765H.9v3.765A.461.461,0,0,1,.45,16,.461.461,0,0,1,0,15.529V.471A.461.461,0,0,1,.45,0ZM16.2,15.059h1.35a.471.471,0,0,1,0,.941h-7.2a.471.471,0,0,1,0-.941H12.6v-8H7.2a.921.921,0,0,1-.9-.941V4.235H4.05a.471.471,0,0,1,0-.941h13.5a.471.471,0,0,1,0,.941H16.2Zm-1.35-8h-.9a.461.461,0,0,0-.45.471v7.059a.461.461,0,0,0,.45.471h.9a.461.461,0,0,0,.45-.471V7.529A.461.461,0,0,0,14.85,7.059ZM5.4,9.412H.9v1.412H5.4V9.412Zm9.45-5.176H7.65a.461.461,0,0,0-.45.471v.941a.461.461,0,0,0,.45.471h7.2a.461.461,0,0,0,.45-.471V4.706A.461.461,0,0,0,14.85,4.235Z",
            "transform": "translate(97.5 408.5)"
          }
        }
      ]
    }
  ]
})
    }
  